const Book = function (quality) {
  return {
    slot: 'off_hand',
    type: 'book',
    quality: quality,
    magicDamageMod: quality * 0.3,
    learning: Math.round(1 + quality * 2.5),
    mana: Math.round(1 + quality * 2.5),
  };
};
module.exports = Book;
